module.exports = __webpack_public_path__ + "static/HSE_Supplement_to_EOM_FINAL-1360714fd4e9587f1007aaa8e099f3c0.pdf";